import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { getFlowKey } from '../routing/getFlowKey';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
import { Step } from '../views/Step';
import { AnimatedStep } from './Animations.styles';
import { Flow } from 'signup-constants/Flow';
const stepsWithAnimationDisabledMobile = [Step.Industry, Step.JobRole];
export const AnimatedStepBody = ({
  animationDelay = false,
  disableAnimation = false,
  children
}) => {
  const {
    isMobile
  } = useResponsiveness();
  const {
    currentStep
  } = useCurrentStep();
  const flowKey = getFlowKey();

  if (disableAnimation || isTransitionAndAnimationsDisabled()) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  const shouldDisableAllAnimations = stepsWithAnimationDisabledMobile.includes(currentStep) && isMobile;
  const disableOnBusinessGoalsStep = flowKey === Flow.Crm && currentStep === Step.BusinessGoals && !isMobile;
  return /*#__PURE__*/_jsx(AnimatedStep, {
    animationDelay: animationDelay,
    currentStep: currentStep,
    disableAnimation: shouldDisableAllAnimations || disableOnBusinessGoalsStep,
    flowKey: flowKey,
    children: children
  });
};